
const Skills = (props) => {
    // console.log(props);

    const skill = props.skills
    // console.log(skill);

    const subskill = props.subskills
    // console.log(subskill);

    const progressColor = ['progress-0', 'progress-1', 'progress-2', 'progress-3', 'progress-4'];

    return (
        <div>
            {skill?.map((item, index) =>

                <div className="skillBox" key={item.id}>
                    <div className="block-title" key={item.id}>
                        <h6 className="title" >
                            {item.title}
                        </h6>
                    </div>
                    <div className="skills">
                        {subskill.filter((element) => (element.skill_id === item.id))?.map((item, index) =>
                            <div className="skils-item" key={item.id}>
                                <div className="skill-info d-flex justify-content-between">
                                    <h4 className="skill-nm mb-0">{item.title}</h4>
                                    <div className="skill-value">{item.percent + '%'}</div>
                                </div>
                                <div className="progress">
                                    <div className={`progress-bar ${progressColor[item.id % 5]}`} style={{ width: item.percent + '%' }}>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )
            }
        </div>
    )
}
export default Skills;